/* eslint-disable no-underscore-dangle */
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-intl-redux'
import { Modal } from '@frontend/ui-kit/agromarket/components/Modal'
import { loadableReady } from '@loadable/component'
import { PoleClientProvider } from '@pole/client/agromarket'
import { Hydrate } from '@tanstack/react-query'
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ConnectedRouter } from 'connected-react-router'
import throttle from 'lodash/throttle'
import { combineEpics } from 'redux-observable'
import ConditionalScrollRestoration from '@/App/components/ConditionalScrollRestoration/ConditionalScrollRestoration'
import { sendMarketingRequest } from '@/sendMarketingRequest'
import './logger.ts'
import 'core-js'
import 'regenerator-runtime/runtime'
import store from './redux/clientStore'
import { reducerManager } from './redux/reducerManager'
import { epic$, rejectOldEpics } from './redux/rootEpic'
import App from './App'
import { history } from './browserHistory'
import { getPolyfills } from './polyfills'
import ScrollToTop from './ScrollToTop'
import { initSentry } from './sentry'
import '@frontend/pole-ui/lib/assets/index.css'
import '@frontend/ui-kit/agromarket/assets/index.css'

initSentry()

const dehydratedState = window['__REACT_QUERY_STATE__']

const ConnectedApp = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <ConditionalScrollRestoration />
      <ScrollToTop />
      <PoleClientProvider clientOptions={{ queries: { staleTime: 40000 } }}>
        <Hydrate state={dehydratedState}>
          <Modal.Provider>
            <App />
            {/*<ReactQueryDevtools initialIsOpen={false} />*/}
          </Modal.Provider>
        </Hydrate>
      </PoleClientProvider>
    </ConnectedRouter>
  </Provider>
)

const renderApp = () => {
  ReactDOM.hydrate(<ConnectedApp />, document.getElementById('root'))
}

getPolyfills().then(() => loadableReady(renderApp))

if (process.env.NODE_ENV === 'production') {
  sendMarketingRequest()
}

if (process.env.NODE_ENV === 'development' && module.hot) {
  const reloadEpics = throttle(() => {
    store.dispatch(rejectOldEpics())
    //eslint-disable-next-line global-require
    const { epicRegistry } = require('./redux/rootEpic')
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    epic$.next((combineEpics as any)(...epicRegistry))
  }, 200)

  const replaceReducer = throttle(() => {
    store.replaceReducer(reducerManager.reduce)
  }, 200)

  // Если ставить optional chaining, то хот релоад не работает
  module.hot.accept('./App', () => {
    reloadEpics()
    setTimeout(renderApp)
    replaceReducer()
  })

  module.hot.accept('./redux/clientStore', () => {
    reloadEpics()
    replaceReducer()
  })

  module.hot.accept('./redux/rootEpic', () => null)
  module.hot.accept('./redux/reducerManager', () => null)
}
